module.exports = __webpack_public_path__ + "img/ceo.c855f049.jpg";